import React from 'react'
import Page from './components/Page'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import New from './components/New'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Navbar from './components/layout/Navbar'
import Footer from './components/layout/Footer'

const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#039598'
		}
	}
})

const useStyles = makeStyles((theme) => ({
	title: {
		fontWeight: 600,
		textAlign: 'center',
		fontSize: 25,
		margin: '1em auto 2em',
		color: '#383838'
	},
	root: {
		maxWidth: '1000px',
		width: '80%',
		margin: '0 auto',
		[theme.breakpoints.down('md')]: {
			width: '100%'
		}
	},
	cobertura: {
		background: '#f5f5f5',
		padding: '40px 40px 80px',
		[theme.breakpoints.down('md')]: {
			padding: 20
		}
	}
}))

function App() {
	const classes = useStyles()
	return (
		<div className="App">
			<ThemeProvider theme={theme}>
				<div>
					<Navbar />

					<Page />
					<section
						id="cobertura"
						className={classes.cobertura}
					>
						<Typography variant="h3" component="h2" className={classes.title}>
							Recomendaciones para la cobertura
						</Typography>
						<Grid container justify="center" className={classes.root} spacing={3}>
							<Grid item md={4} sm={6} xs={12}>
								<Grid container justify="center">
									<New
										image="https://fundacionmohme.org/wp-content/uploads/2020/04/jacq-fowks-1024x563.jpg"
										title="Jacqueline Fowks: criterios para cubrir la emergencia de la Covid-19 en regiones"
										url="https://fundacionmohme.org/noticias/jacqueline-fowks-criterios-para-cubrir-la-emergencia-de-la-covid-19-en-regiones-video/"
									/>
								</Grid>
							</Grid>
							<Grid item md={4} sm={6} xs={12}>
								<Grid container justify="center">
									<New
										image="https://fundacionmohme.org/wp-content/uploads/2020/04/marco-sifuentes-1280x720-1-1024x576.jpg"
										title="Marco Sifuentes: Cuatro pautas para la cobertura de la Covid-19 en regiones"
										url="https://fundacionmohme.org/noticias/marco-sifuentes-cuatro-pautas-para-la-cobertura-del-covid-19-en-regiones-video/"
									/>
								</Grid>
							</Grid>
							<Grid item md={4} sm={6} xs={12}>
								<Grid container justify="center">
									<New
										image="https://fundacionmohme.org/wp-content/uploads/2020/03/HVANNUBC4JBOPPXVG5SLULIDVA.jpg"
										title="La cobertura de la Covid-19 y la protección del periodista"
										url="https://fundacionmohme.org/noticias/la-cobertura-del-covid-19-y-la-proteccion-del-periodista/"
									/>
								</Grid>
							</Grid>
						</Grid>
					</section>
					<Footer />
				</div>
			</ThemeProvider>
		</div>
	)
}

export default App
